import React from 'react';
import {WebUI} from "../../wui-core/src/index"
import Checkbox from './Checkbox';
import { CheckboxProps } from './iCheckbox';

const CheckboxButton: React.FC<CheckboxProps> = (props) => {
    return (
        <Checkbox {...props} />
    );
};

export default WebUI({name: "checkbox-button"})(CheckboxButton);
